import React from 'react'; // Import React, which is necessary for creating the component
import { Link } from 'react-router-dom'; // Import 'Link' from 'react-router-dom' for internal navigation
import '../css/footer.css'; // Import the CSS file for styling the Footer component
// Define the Footer component
const Footer = () => {
    return (
        <div className="footer"> {/* The main container for the footer */}
            {/* Display a copyright notice */}
            <p>&copy; All Rights Reserved 2025</p>
        </div>
    );
};

// Export the Footer component so it can be imported and used in other files
export default Footer;
